@let t = text();

@if (isCycleMode()) {
  <!-- Cycle-modus: blokje met links het keynote-icoon; regel 1 = kanaal-keynote
       (vet) + design-keynote, regel 2 = de poort-chips. De labels blijven hier weg. -->
  <div class="hd-channel-list-item__block" [style.--keynote-color]="keynoteMeta()?.color ?? null">
    @if (keynoteMeta(); as keynote) {
      <i class="fas fa-{{ keynote.faIcon }} hd-channel-list-item__block-icon" aria-hidden="true"></i>
    }
    <div class="hd-channel-list-item__block-body">
      <button type="button" class="hd-channel-list-item__link" (click)="onChannelClick($event)">
        <span class="hd-channel-list-item__keynote">{{ t.name }}</span>, {{ t.shortDescription }}
      </button>
      <span class="hd-channel-list-item__chips">
        @for (side of chipSides(); track side.gate; let last = $last) {
          <hd-cycle-gate-keynote-line
            [gate]="side.gate"
            [source]="side.source"
            [activations]="side.source === 'natal' ? side.natalActivations : side.cycleActivations"
            [secondaryActivations]="showBothSourceGlyphs() && side.source === 'both' ? side.natalActivations : []"
            [encounter]="side.encounter"
            (gateInfoRequested)="gateInfoRequested.emit($event)"
          />
          @if (!last) {
            <span class="hd-channel-list-item__chip-dash" aria-hidden="true">-</span>
          }
        }
        @if (annotation(); as parts) {
          <span class="hd-channel-list-item__annotation">
            @for (part of parts; track $index) {
              @if (part.text) {
                <span [style.color]="part.color ?? null">{{ part.text }}</span>
              }
              @if (part.glyphs?.length) {
                <span class="hd-channel-list-item__annotation-glyphs"
                      [style.color]="part.color ?? null" aria-hidden="true">
                  @for (glyph of part.glyphs; track $index) {
                    <span class="hd-channel-list-item__annotation-glyph">{{ glyph }}</span>
                  }
                </span>
              }
            }
          </span>
        }
      </span>
    </div>
    @if (expandable()) {
      <hd-cycle-cards-toggle [expanded]="expanded()" (toggle)="expandToggled.emit()" />
    }
  </div>
} @else {
  <!-- Basis-modus: kanaalkaartje. Links het circuit-thema-icoon in de circuitkleur;
       regel 1 naam + mini-kanaaltje, regel 2 het design, regel 3 circuit · centers ·
       kanaaltype. Klik op het kaartje (of de naam, voor het toetsenbord) → kanaal-info;
       een poort-badge → gate-info. -->
  @let c = card();
  <div class="hd-channel-list-item__card"
       [style.--circuit-color]="c.circuitColor"
       (click)="onChannelClick($event)"
       (mouseenter)="onCardEnter()"
       (mouseleave)="onCardLeave()">
    @if (c.circuitIcon) {
      <span class="hd-channel-list-item__card-icon" [attr.title]="c.circuitTooltip" aria-hidden="true">
        <i [class]="'fad fa-' + c.circuitIcon"></i>
      </span>
    }
    <div class="hd-channel-list-item__card-body">
      <div class="hd-channel-list-item__card-head">
        <button type="button" class="hd-channel-list-item__link hd-channel-list-item__card-name"
                (click)="onChannelClick($event)">{{ t.name }}</button>
        <!-- Mini-kanaaltje: poort · verbinding · poort, de glyphs telkens naar buiten. -->
        <span class="hd-channel-list-item__mini-channel">
          @for (side of c.gates; track side.gate; let first = $first) {
            @if (first) {
              <ng-container *ngTemplateOutlet="glyphs; context: { $implicit: side }" />
              <ng-container *ngTemplateOutlet="gateBadge; context: { $implicit: side }" />
            } @else {
              <span class="hd-channel-list-item__mini-connector" aria-hidden="true"></span>
              <ng-container *ngTemplateOutlet="gateBadge; context: { $implicit: side }" />
              <ng-container *ngTemplateOutlet="glyphs; context: { $implicit: side }" />
            }
          }
        </span>
      </div>
      @if (t.shortDescription) {
        <div class="hd-channel-list-item__card-description">
          <span class="hd-channel-list-item__card-description-label">{{ t.descriptionPrefix }}</span>{{ t.shortDescription }}{{ t.descriptionSuffix }}
        </div>
      }
      <div class="hd-channel-list-item__card-meta">
        @if (c.circuitName) {
          <span class="hd-channel-list-item__meta-item" [attr.title]="c.circuitTooltip">{{ c.circuitName }}</span>
        }
        @if (c.centers.length) {
          <span class="hd-channel-list-item__meta-item hd-channel-list-item__meta-centers">
            @for (center of c.centers; track $index; let last = $last) {
              <span class="hd-channel-list-item__center-dot" [style.background-color]="center.color" aria-hidden="true"></span>{{ center.name }}@if (!last) {<span class="hd-channel-list-item__meta-dash" aria-hidden="true">–</span>}
            }
          </span>
        }
        @if (c.typeLabel) {
          <span class="hd-channel-list-item__meta-pill" [attr.title]="c.typeHint">{{ c.typeLabel }}</span>
        }
        @for (badge of c.badges; track badge) {
          <span class="hd-channel-list-item__meta-pill hd-channel-list-item__meta-pill--accent">{{ badge }}</span>
        }
      </div>
    </div>
  </div>
}

<ng-template #gateBadge let-side>
  <button type="button"
          class="hd-channel-list-item__mini-gate hd-channel-list-item__mini-gate--{{ side.source }}"
          [attr.title]="side.tooltip || null"
          (click)="onGateClick(side.gate, $event)">{{ side.gate }}</button>
</ng-template>

<ng-template #glyphs let-side>
  @if (side.glyphs.length) {
    <span class="hd-channel-list-item__mini-glyphs">
      @for (glyph of side.glyphs; track $index) {
        <span class="hd-channel-list-item__mini-glyph hd-channel-list-item__mini-glyph--{{ glyph.side }}"
              [attr.title]="glyph.title">{{ glyph.char }}</span>
      }
    </span>
  }
</ng-template>
